export default () => {
  const token = window.localStorage.getItem('token');
  return token || false;
};
